import type { LocalizedDict } from '../index'

export type DateTimePickerStrings = {
  previousMonth: string
  nextMonth: string
  clear: string
  apply: string
  emptyValue: string
  chooseDate: (label: string) => string
  chooseRange: (label: string) => string
  presetsLabel: string
  presets: {
    today: string
    last7Days: string
    last14Days: string
    thisMonth: string
  }
  weekdays: string[]
  months: string[]
}

export const dateTimePickerI18n: LocalizedDict<DateTimePickerStrings> = {
  en: {
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    clear: 'Clear',
    apply: 'Apply',
    emptyValue: 'Select date',
    chooseDate: (label) => `Choose ${label.toLowerCase()}`,
    chooseRange: (label) => `Choose ${label.toLowerCase()} range`,
    presetsLabel: 'Date presets',
    presets: {
      today: 'Today',
      last7Days: 'Last 7 days',
      last14Days: 'Last 14 days',
      thisMonth: 'This month',
    },
    weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
  },
  tr: {
    previousMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    clear: 'Temizle',
    apply: 'Uygula',
    emptyValue: 'Tarih seç',
    chooseDate: (label) => `${label} seç`,
    chooseRange: (label) => `${label} aralığını seç`,
    presetsLabel: 'Tarih kısayolları',
    presets: {
      today: 'Bugün',
      last7Days: 'Son 7 gün',
      last14Days: 'Son 14 gün',
      thisMonth: 'Bu ay',
    },
    weekdays: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    months: [
      'Ocak',
      'Şubat',
      'Mart',
      'Nisan',
      'Mayıs',
      'Haziran',
      'Temmuz',
      'Ağustos',
      'Eylül',
      'Ekim',
      'Kasım',
      'Aralık',
    ],
  },
}
